import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { closeDeleteModal } from "../../../../../../store/redux/slice/ComponentsControl/adminConsoleConfigControl";
import { toast } from "react-toastify";
import { ConfirmDialog } from "@duosoftbg/nacid-components";
import React from "react";
import { renewAcCache } from "../../../../../../store/redux/slice/AppData/aConsoleData";

const AdminConsoleDeleteDialog = ({ section, title, message, serviceFn }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.acConfigControl.sections[section].modals.delete;
  });

  const handleCloseDialog = () => {
    dispatch(closeDeleteModal({ section: section }));
  };

  const onSuccess = (response) => {
    dispatch(renewAcCache(response));
    handleCloseDialog();
    toast.success(t("m.save.data.success"));
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={handleCloseDialog}
      onError={handleCloseDialog}
      promiseFunction={() => serviceFn(id)}
      onSuccess={onSuccess}
      title={title}
      message={message}
      showBackdrop={false}
    />
  );
};
export default AdminConsoleDeleteDialog;
